import { Component, EventEmitter, forwardRef, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseService } from '../../services/base.service';

@Component({
  selector: 'app-color',
  templateUrl: './color.component.html',
  styleUrls: ['./color.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => ColorComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ColorComponent {
  @Input() label: string = '';
  @Input() input: string = '';
  @Input() colors: string[] = [];

  @Output() onValueChange = new EventEmitter();
  @Output() onClearChange = new EventEmitter<Event>();

  constructor(protected readonly baseService: BaseService) {}

  onChange = (data: any) => {};
  onTouch = (_: any) => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(value: string) {
    this.input = value;
    this.onChange(value);
  }

  onchange(event: any) {
    this.input = event;
    this.onChange(event);
    this.onValueChange.emit(event);
  }

  onClear(event?: any) {
    this.onClearChange.emit(event);
  }

  close() {}

  save() {}

  protected readonly Object = Object;
}
